"use client";

import { useFormStatus } from "react-dom";

import type { ButtonProps } from "@gsa/ui/button";
import { Button } from "@gsa/ui/button";
import { Icons } from "@gsa/ui/icons";

export function SubmitButton(
  props: ButtonProps & {
    action?: () => void;
  },
) {
  const { pending } = useFormStatus();

  return (
    <Button
      {...props}
      type="submit"
      aria-disabled={pending}
      disabled={pending}
      formAction={props.action}
    >
      {pending ? <Icons.spinner className="h-4 w-4" /> : props.children}
    </Button>
  );
}
